
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93xBq9ueGMVrzweOxEqTLoFH9_b_E8zsIDPI2PqZfhDxUMeta } from "/codebuild/output/src601102160/src/ark/pages/[...slug].vue?macro=true";
import { default as guiaseaTvjNoDzfqam_PkUmie0Qv4LCn68gxuqlP8fiYtypUMeta } from "/codebuild/output/src601102160/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexw7SJI6Gm1Jx97CNEfGD4VP8ktdthi_45Eb_PgZsjEtBvkMeta } from "/codebuild/output/src601102160/src/ark/pages/blog/index.vue?macro=true";
import { default as temasfqhma2cvoQV4uHQhb35ffTJgS8TSRTlaHluyVi0eQ2sMeta } from "/codebuild/output/src601102160/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisaA9aYs2IFheEOvzA0UsAfbI6xJ2S3JSrHnUdiQY7MUCUMeta } from "/codebuild/output/src601102160/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradab2JhUI38RLrwmeNBjr46Z_k3cVfG7rS5hJxqOCypYOUMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesYpzXb7xdtAVZSLX0XQX_45rpKSMeJmna6TDI6x_45vrRALMMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasKZzTWJCw7RPptCzi1jpeXfwSTSYc8aQctAtD4TwhXfMMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casasTnn4uZFIUjmifa0ksMqD6_45_45OS8dVM9SEjtHhi7UZDIMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtoSgBOn_kpUW_45f8oZ2koYUZx0TMwnOCrBrd_45mcN91BOmkMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadorah_45_45NEAxfpRQDEstGrYRfI8L4299cZeNwNSrHcMtHU8YMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contacto0iFsqiDEMSHKAIOkic4I3m4ttqlFr2RClwxVldoJAo8Meta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratada4bOGqtEmT3_5FDINMTkn3IkVZCMbO9oSKEruNqc0dlgMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularhWmbVGPNSdKaLWpH9_45N_45U_45MkHPF5uTaKIa2_4540FwUYIMeta } from "/codebuild/output/src601102160/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetWIcSsKGuVzifcQGfrYaDzeVknL5CKVvUq_45fasKicAcQMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemoveli4mBZDRzdA8o0l1_45XwpJ6bdswMi_452vAWaxGZcOM_Gv8Meta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoJ0yipLUZxFpJLGAytBA_45HwwCvCe_452MNzoJqjUU2OlNYMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualCPzqg3krquPJGxm0hc1OMaqSqdsMJLZjITR1mMlWI6IMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoX4CwvTrkxNexrdDt6J9FWQ6UTqM8OOl_45lSpsXMJ_458a8Meta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularX8jqXUVde1Kio1VJz4ugIf5c8G3VLlSmvmyER0VE7FUMeta } from "/codebuild/output/src601102160/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93u_45qNai7ovN9YJLs_45fUpSpFqXhTzwOmIHpOqlLyLbW5kMeta } from "/codebuild/output/src601102160/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93R8UqolCMmFtPQBD7tvjzL_45jJZW7M6TXT6LZaZdB4FLIMeta } from "/codebuild/output/src601102160/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoLdtj_45Zf2M7SI_45ILjnqesEwMN7wcyKi_45q4jT6BuaBYq4Meta } from "/codebuild/output/src601102160/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeWLul2NMQEcnbWo7V52PzYUiwvjrN9Uvx5qvVL0Ncl_oMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxa_45OiIn_45vpiXPBBZqAJ_AbcTTdt9IsXejiCc9d54kxjGYMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactoHAKgA8Cc6n4sHD3FSpva_w9iTG0hcLjtlbikRZpck74Meta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoPp746H_451ytfNi2HWPVUJau1IAJk6OUc_45ehUnvEZLC0kMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiraIG2mO4yiF9pat_459_45NKKDYDNLtI_zyMByyyl8Z3W2mxAMeta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimo_45wTkDoateTkiBBtTA9FAQkf0yV3W3BgBXSbKT5OsnN4Meta } from "/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularG_45wE_JgVaZV62gyhA2ADsryoOuwxxRmIwXFWa4Qj1bMMeta } from "/codebuild/output/src601102160/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_937s1uY_454UM677xSakj1HKzX579mkPOLDANBSazLfCWWYMeta } from "/codebuild/output/src601102160/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosk7S7LLRXkQqRE8kwLcaO722HNjkpne68cMGpcWO22ckMeta } from "/codebuild/output/src601102160/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexSlWCcOjWIDWIUEPL_dz8WojgRUnepTHOeu5PeH_45LW8kMeta } from "/codebuild/output/src601102160/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93_45nDICdnXnRJ3wi7wMLnFUfro3vwGDGrYZvZc3fWX6jUMeta } from "/codebuild/output/src601102160/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93Ld0vf8x9eEROmIiF8H80Nnu4TIdeqwyhWzXGD_rvqfoMeta } from "/codebuild/output/src601102160/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simularhWmbVGPNSdKaLWpH9_45N_45U_45MkHPF5uTaKIa2_4540FwUYIMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src601102160/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularX8jqXUVde1Kio1VJz4ugIf5c8G3VLlSmvmyER0VE7FUMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src601102160/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularG_45wE_JgVaZV62gyhA2ADsryoOuwxxRmIwXFWa4Qj1bMMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src601102160/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src601102160/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_937s1uY_454UM677xSakj1HKzX579mkPOLDANBSazLfCWWYMeta || {},
    component: () => import("/codebuild/output/src601102160/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosk7S7LLRXkQqRE8kwLcaO722HNjkpne68cMGpcWO22ckMeta || {},
    component: () => import("/codebuild/output/src601102160/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src601102160/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93_45nDICdnXnRJ3wi7wMLnFUfro3vwGDGrYZvZc3fWX6jUMeta || {},
    component: () => import("/codebuild/output/src601102160/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93Ld0vf8x9eEROmIiF8H80Nnu4TIdeqwyhWzXGD_rvqfoMeta || {},
    component: () => import("/codebuild/output/src601102160/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]